import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Components as LabelComponents } from './label.style';
import Icon from '../../components/Icon';
import Tooltip from '../../components/Tooltip';
const Label = _ref => {
  let {
    id,
    className,
    label,
    showOptional,
    required,
    tooltipDescription,
    tooltipDescriptionPosition = 'right',
    fit = 'medium',
    orientation = 'vertical'
  } = _ref;
  return _jsx(_Fragment, {
    children: _jsxs(LabelComponents.Label, _extends({
      className: "".concat(className, "-label"),
      htmlFor: id,
      fit: fit,
      orientation: orientation
    }, {
      children: [_jsxs("span", {
        children: [label, showOptional && !required && _jsx("span", _extends({
          className: "optional"
        }, {
          children: "(optional)"
        })), required && _jsx("span", {
          className: "required"
        })]
      }), !!tooltipDescription && _jsx(LabelComponents.LabelTooltip, _extends({
        height: '20'
      }, {
        children: _jsx(Tooltip, _extends({
          fit: fit,
          content: tooltipDescription,
          width: 'auto',
          position: tooltipDescriptionPosition,
          appearance: "default"
        }, {
          children: _jsx(Icon, {
            name: "info-circle",
            size: '20'
          })
        }))
      }))]
    }))
  });
};
export default Label;